const AppErrorPage = ({ message }: { message: string }) => (
  <div style={{ width: "100%", textAlign: "center" }}>
    <div style={{ color: "#f7f7f7", fontSize: "16pt", marginTop: "130px", display: "flex", flexDirection: "column", alignItems: "center" }}>
      <img alt="logo" src="/icon.png" style={{ height: "50px", width: "50px" }} />
      <p>{message}</p>
    </div>
  </div>
);

export default AppErrorPage;
